import { CssBaseline, Box, Toolbar } from '@mui/material';
import { FC, ReactNode } from 'react';
import Header from '../header';
import Sidebar from '../sidebar';

type LayoutProperties = {
  children: ReactNode;
};

const Layout: FC<LayoutProperties> = ({ children }) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      <Header />

      <Sidebar />

      {/* Main Content */}
      <Box sx={{ width: '100%' }}>
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
